import { createSelector } from '@reduxjs/toolkit';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'slices';

interface IState {
  loading: boolean;
}
export const LayoutHook = () => {
  const selectLayout = (state: RootState) => state.Layout;
  const properties = createSelector([selectLayout], (e) => ({
    loading: e.loading,
  }));

  const { loading } = useSelector(properties);

  const [state, setState] = useState<IState>({
    loading,
  });

  useEffect(() => {
    setState((v) => ({ ...v, loading }));
  }, [loading]);

  return state;
};
